import { Component, OnInit, Output,EventEmitter } from '@angular/core';

@Component({
  selector: 'sm-custom-context-menu-for-chat-threads',
  templateUrl: './custom-context-menu-for-chat-threads.component.html',
  styleUrls: ['./custom-context-menu-for-chat-threads.component.scss']
})
export class CustomContextMenuForChatThreadsComponent implements OnInit {
  @Output() menuItemClicked = new EventEmitter<string>();
  
  constructor() { }

  ngOnInit(): void {
  }
  handleMenuItemClick(option: string) {
    this.menuItemClicked.emit(option);
  }
}
